export function isSuperAdmin(roles: readonly string[]): boolean {
  return roles.includes('SUPERADMIN');
}

export function isCityModerator(roles: readonly string[]): boolean {
  return roles.includes('CITY_MODERATOR');
}

/** Глобальные справочники (категории, источники, парсер) — правит только SUPERADMIN. */
export function canEditGlobalCatalog(roles: readonly string[]): boolean {
  return isSuperAdmin(roles);
}

/** Монетизация в админке — менеджер города только смотрит. */
export function canEditMonetization(roles: readonly string[]): boolean {
  return isSuperAdmin(roles);
}

export function canAccessOrganizerBlocks(roles: readonly string[]): boolean {
  return isSuperAdmin(roles);
}

export function canAccessUserRegistry(roles: readonly string[]): boolean {
  return isSuperAdmin(roles);
}

export function canManageCities(roles: readonly string[]): boolean {
  return isSuperAdmin(roles);
}
